import strings from "../utils/locals/languages";

const menuItems = [
    { label: strings.myProfile, path: "/profile" },
    { label: strings.AdManagement, path: "/ads-management" },
    { label: strings.balance },
    {
        label: strings.fav,
        path: "/favorites",
        requiresAuth: true,
        warning: strings.loginWarn
    },
    { label: strings.messages },
    { label: strings.packages, path: "/packages" },
    {
        label: strings.lang,
        extra: <span className="text-orange-400 ml-2">{strings._language}</span>
    },
    {
        label: strings.Priv,
        path: "/privacy-policy",
        requiresAuth: true,
        warning: strings.loginWarn
    },
    {
        label: strings.faqs,
        path: "/faq",
        requiresAuth: true,
        warning: strings.loginWarn
    },
    {
        label: strings.reportProb,
        path: "/reportproblem",
        requiresAuth: true,
        warning: strings.loginWarn
    },
    {
        label: strings.about,
        path: "/aboutus",
        requiresAuth: true,
        warning: strings.loginWarn
    },
    {
        label: strings.deleteAccount,
        action: "deleteAccount"
    },
    {
        label:  strings.logout,
        action: "toggleAuth"
    }
];

export default menuItems;
